import { Col, Button } from 'antd'
import React, { useEffect, useState } from 'react'
import UserActivitiesRow from "./UserActivitiesRow"
import F from "../../../../Functions"
import ViewAllAppointment from './ViewAllAppointment'
import moment from 'moment'
import review from '../../../../assets/icons/dashboard/review.png'
import leads from '../../../../assets/icons/dashboard/lead.png'
import opportunities from '../../../../assets/icons/dashboard/opportunities.png'
import { AGENCY_MANAGER } from '../../../../utils/Constants'

function User_activity_card({ md, activity_name, style, buttonStyle, className = "", data = {}, state, refresh,
  appointment_name = "", isGlobalDashboard = false, props }) {
  const [card_Data, setcard_Data] = useState([])
  const [isViewAppoinmentModal, setIsViewAppoinmentModal] = useState(false)

  const images = {
    Review: review,
    Leads: leads,
    Opportunities: opportunities,
  }

  const buttons = {
    Review: "Review",
    Leads: "Lead",
    Opportunities: "Opportunity",
  }

  const currentMonth = moment().format('MMM');

  useEffect(() => {
    if (state.user.user_type == AGENCY_MANAGER) {
      setcard_Data(F.get_user_activity_card_data_agency_manager(state.dashboard.card_data, state.type_of_call));
    } else {
      setcard_Data(F.get_user_activity_card_data(state.dashboard.card_data, state.type_of_call));
    }

  }, [state.dashboard.card_data, state.type_of_call, state.user.user_type])

  return (
    // <Col style={style} span={24} md={md} className={`user_activites_card ${className} custom-card`}>
    <Col style={style} span={24} md={md} className={`user_activites_card`}>
      <img width={40} style={{ position: "absolute", left: 0, top: 0 }} src={images[`${activity_name}`]} alt="" />
      {/* <div className={`activity_name ${state.vonboard == 0 && state.review == 1 ? 'custom-padding' : ''}`} */}
      <div className={`activity_name`}
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '15px' }}>
        {activity_name}
        <Col span={8} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
          {state.isAllBfiles === true && <span className=''>{currentMonth}</span>}
          <span className='' >Total</span>
        </Col>
      </div>
      {/* <div className={`${state.vonboard == 0 && state.review == 1 ? 'custom-padding' : ''}`}> */}
      <div className={``}>
        {card_Data && card_Data.map((e, index) => {
          return (<UserActivitiesRow key={index} type_of_call={state.type_of_call} link={e.link} img={e.icon} monthly_count={e.monthly_count} total_count={e.total_count} name={e.name} state={e.state} isAllBfiles={state.isAllBfiles} isGlobalDashboard={isGlobalDashboard} props={props} />)
        })}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
        {/* {card_Data && <Button onClick={() => setIsViewAppoinmentModal(true)} style={buttonStyle} className='activites_view'>View Appointments</Button>} */}
        {card_Data && <Button onClick={() => {
          localStorage.removeItem("agGridColumnState")
          setIsViewAppoinmentModal(true)
        }
        }
          className={`activites_view ${activity_name}
        ${state.vonboard == 0 && state.review == 1 ? 'btn-width-230' : ''}`}>
          {buttons[activity_name]} Appointments
        </Button>
        }
        {isViewAppoinmentModal && <ViewAllAppointment
          isViewAppoinmentModal={isViewAppoinmentModal}
          cancelViewAppoinmentModal={() => setIsViewAppoinmentModal(false)}
          dashboard={state.dashboard}
          filter_lsp={state.filter_lsp}
          internalFilterChange={state.internalFilterChange}
          start_date={state.start_date}
          end_date={state.end_date}
          period={state.period}
          user={state.user}
          associations={state.associations}
          refresh={() => refresh()}
          type_of_call={state.type_of_call}
          appointment_name={appointment_name}
          isGlobalDashboard={isGlobalDashboard}
          isFromAllViewAppointment={false}
          vonboard={state.vonboard}
          review={state.review}
          // is_lead={state.is_lead}
          is_lead={state.show_lead_card_appointment_details}
          is_opportunity={state.is_opportunity}

        />}
      </div>
    </Col>
  )
}

export default User_activity_card



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/UserActivityCard.js